export const cardStyle = {
  borderRadius: 1,
  py: 1,
  px: 2,
  bgcolor: 'background.default',
  width: '100%',
}
